import { Toast, ToastInfo } from 'zens-storybook'
import { observer } from 'mobx-react-lite'
import React, { PropsWithChildren } from 'react'
import { useStore } from 'zens-store'

type Props = object
const ToastProvider = (props: PropsWithChildren<Props>) => {
  const { children } = props
  const { message } = useStore()

  const close = (info: ToastInfo) => {
    const id = typeof info.id === 'string' ? parseInt(info.id, 10) : info.id
    message.remove(id)
  }
  return (
    <>
      {children}
      <Toast messages={message.all} onClose={close} />
    </>
  )
}

export default observer(ToastProvider)
